import { useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { userActions, learningItemActions, groupActions } from './store'

export const ReturnsUsers = 'ReturnsUsers'
export const ReturnsGroups = 'ReturnsGroups'
export const ReturnsLearningItems = 'ReturnsLearningItems'
export const ReturnsUserLearningAssignments = 'ReturnsUserLearningAssignments'
export const ReturnsGroupLearningAssignments = 'ReturnsGroupLearningAssignments'
export const ReturnsFavorites = 'ReturnsFavorites'
export const ReturnsNotifications = 'ReturnsNotifications'
export const ReturnsNotificationCount = 'ReturnsNotificationCount'
export const ReturnsAssets = 'ReturnsAssets'
export const ReturnsComments = 'ReturnsComments'
export const ReturnsUserBookedLearningItems = 'ReturnsUserBookedLearningItems'
export const ReturnsPathLearningItems = 'ReturnsPathLearningItems'

export default function useInvalidate() {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  return useMemo(() => {
    return {
      users: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsUsers) })
        dispatch(userActions.invalidateAll())
      },
      groups: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsGroups) })
        dispatch(groupActions.invalidateAll())
      },
      courses: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsLearningItems) })
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsAssets) })
        dispatch(learningItemActions.invalidateAll())
      },
      userLearningAssignments: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsUserLearningAssignments) })
      },
      groupLearningAssignments: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsGroupLearningAssignments) })
      },
      favorites: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsFavorites) })
      },
      notifications: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsNotifications) })
      },
      notificationCount: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsNotificationCount) })
      },
      assets: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsAssets) })
      },
      comments: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsComments) })
      },
      useUserBookedLearningItems: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsUserBookedLearningItems) })
      },
      pathLearningItems: () => {
        queryClient.invalidateQueries({ predicate: (q) => q.queryKey.includes(ReturnsPathLearningItems) })
      },
    }
  }, [queryClient.invalidateQueries])
}
